import ManagersContext from '../../containers/ManagersContext'
import { useContext } from 'react'
import funride from '../../lib/funride/funride.module.less'

export default function InnerPageDissertation () {
  const { docsManager } = useContext(ManagersContext)
  return (
    <div>
      <header>
        <h1>PhD Dissertation: 'Blend'</h1>
        <p>
          Here are links to the Dissertation I wrote for my PhD in Music from Northwestern University: <i>Concurrent Timbres in Orchestration: a Perceptual Study of Factors Determining 'Blend'</i>.
        </p>
      </header>
      <section>
        <dl>
          <dt>In smaller-sized parts</dt>
          <dd>
            <ul className={funride.singleLines}>
              <li><a href={docsManager.get('01_diss_cover_TOC')}>Cover, Table of Contents, etc. (4.9 mb)</a></li>
              <li><a href={docsManager.get('02_diss_chapter_1')}>Chapter 1: Introduction (23.9 mb)</a></li>
              <li><a href={docsManager.get('03_diss_chapter_2')}>Chapter 2: Perceptual Research and "Blend" (8.6 mb)</a></li>
              <li><a href={docsManager.get('04_diss_chapter_3')}>Chapter 3: Method for Investigating "Blend" (23.7 mb)</a></li>
              <li><a href={docsManager.get('05_diss_chapter_4')}>Chapter 4: Experiments in Blend Perception (36.8 mb)</a></li>
              <li><a href={docsManager.get('06_diss_chapter_5')}>Chapter 5: Concluding Remarks (5 mb)</a></li>
              <li><a href={docsManager.get('07_diss_references')}>References (4.3 mb)</a></li>
            </ul>
          </dd>
          <dt>One large PDF</dt>
          <dd><a href='https://www.dropbox.com/s/cs6c1qslhjd5ww2/gregSandell1991DissertationEntire.pdf?dl=0'>Whole Dissertation (107 mb)</a>
          </dd>

        </dl>
      </section>
    </div>
  )
}
